﻿import Dialog from '../core/Dialog';
import { createButton } from './dialogCommonApi';
import SvgManager from '../core/SvgManager';
import getResource from '../core/resources';

const images = {
	warning: '../images/Warning.svg'
};

SvgManager.enqueue(Object.values(images));

function confirmModule(message = '', options = {}) {
	const {
		additionalButton,
		cancelButtonModifier,
		okButtonModifier,
		okButtonText,
		title,
		image = images.warning
	} = options;
	const cssClassName = 'aras-dialog-confirm';
	const confirmDialog = new Dialog('html', {
		classList: cssClassName,
		title: title || getResource('common.confirm_title')
	});
	const imageNode = SvgManager.createHyperHTMLNode(image, {
		class: `${cssClassName}__img`
	});
	const okBtn = createButton(
		okButtonText || getResource('common.ok'),
		`${okButtonModifier || 'aras-button_primary'}`,
		confirmDialog.close.bind(confirmDialog, 'ok'),
		true
	);
	const cancelBtn = createButton(
		getResource('common.cancel'),
		`${cancelButtonModifier || 'aras-button_secondary-light'}`,
		confirmDialog.close.bind(confirmDialog, 'cancel')
	);
	let additionalBtnNodes;
	if (additionalButton) {
		// add width for default 24 rem with if we have more thatn one button.
		confirmDialog.dialogNode.style.width =
			24 + (additionalButton.length - 1) * 8 + 'rem';
		additionalBtnNodes = additionalButton.map((addBtn) => {
			const { actionName, buttonModifier, text } = addBtn;
			return createButton(
				text,
				`${buttonModifier || 'aras-button_secondary'}`,
				() => confirmDialog.close(actionName)
			);
		});
	}
	const html = HyperHTMLElement.hyper(confirmDialog.contentNode);

	html`
		<div class="${cssClassName + '__container'}">
			${imageNode}
			<span class="${cssClassName + '__text'}">${message}</span>
		</div>
		<div class="${cssClassName + '__container'}">
			${okBtn} ${additionalBtnNodes} ${cancelBtn}
		</div>
	`;

	confirmDialog.show();
	return confirmDialog.promise;
}

export default confirmModule;
